// Module
var code = "<span>{{$ctrl.totalVolume | bringozVolume:true}}</span> ";
// Exports
export default code;